import LogoVipEs from '../../src/legacy/LogoVipEs';
export default LogoVipEs;
